/* =================================================================
   SD ADD-ONS — PRODUCT PAGE
   -----------------------------------------------------------------
   The "Complete your order" rows under the buy button.

   Three kinds of row, and the difference between them is the whole
   feature:

     • priced-off-sofas (Premier Delivery) — charged by VAN LOAD. Up
       to 3 sofas share one £49.99 fee; 4 or more pay double, and it is
       capped there. The row shows the line price so the shopper is not
       surprised at checkout. It used to go in at one per sofa, which
       billed a 3+2+1 order £149.97 for a single van turning up once.
       The sum lives in ONE place — snippets/sd-delivery-qty.liquid,
       via window.sdFollowQty — because six callers need it and any two
       disagreeing shows one price and bills another.
     • configurable (Sofa Removal) — always quantity 1. Its dropdown
       already says how many pieces, so multiplying would charge twice.
     • care plan    — always quantity 1, but PRICED IN BANDS off the
       shopper's COMBINED sofa spend: what is already in the basket
       plus the sofa about to be added. Sizes in a range are separate
       products, so pricing off one line would under-price the cover.

   The band maths lives in snippets/sd-addon-tier-pick.liquid and is
   mirrored here only for the live preview; assets/sd-addons-cart.js
   owns it once the item is in the basket.

   This file does NOT add anything to the cart. The theme's own
   Add-to-Cart (assets/sd-product.js -> doAddToCart) already collects
   .sd-addon__check:checked, so add-ons ride along on the one request
   that adds the sofa. That is deliberate: two requests means a failed
   add-on can land after the sofa and leave the drawer half-built.
   ================================================================= */
(function () {
  'use strict';

  var NUDGE_KEY = 'sdAddonNudgeSeen';

  function money(pence) {
    var fmt =
      (window.Shopify && window.Shopify.money_format) ||
      (window.theme && window.theme.moneyFormat) ||
      '£{{amount}}';
    var amount = (pence / 100).toFixed(2);
    function group(v) {
      var parts = String(v).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, group(Math.round(pence / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, group(amount))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function toInt(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  /* snippets/sd-delivery-qty.liquid owns the rule. Falling back to 1 when it
     is absent is deliberate: a missing rule is a bug, and quoting one delivery
     too few is recoverable where silently billing one per sofa is not. */
  function followQty(sofaQty) {
    return window.sdFollowQty ? window.sdFollowQty(sofaQty) : 1;
  }

  /* ── What the basket already holds ──
     Read from the same Liquid-stamped payload the basket controller
     uses, so the product page and the basket never disagree about what
     counts as a sofa. Absent (no drawer on the page) means an empty
     basket, which is the safe reading: the preview then quotes off the
     current product alone. */
  function basketSofas() {
    var el = document.querySelector('[data-sd-addon-lines]');
    if (!el) return { spend: 0, qty: 0, leather: false };
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return { spend: 0, qty: 0, leather: false };
    }
    var spend = 0;
    var qty = 0;
    var leather = false;
    (data.lines || []).forEach(function (l) {
      if (l.addon || l.carePlan || l.qtyFollow || !l.sofa) return;
      spend += l.linePrice;
      qty += l.qty;
      if (l.leather) leather = true;
    });
    return { spend: spend, qty: qty, leather: leather };
  }

  function SdAddons(root) {
    this.root = root;
    this.rows = Array.prototype.slice.call(root.querySelectorAll('[data-addon-row]'));
    this.careRow = root.querySelector('[data-addon-care]');
    this.tiers = [];
    if (this.careRow) {
      try {
        this.tiers = JSON.parse(this.careRow.getAttribute('data-addon-tiers') || '[]');
      } catch (e) {
        this.tiers = [];
      }
    }
    this.coversNote = root.getAttribute('data-addon-covers-note') || '';
    this.sectionId = root.getAttribute('data-addon-section') || '';
  }

  /* The sofa quantity this page is about to add. The multi-buy card
     replaces the stepper when it is on the page, because the bundle is
     what actually gets posted. */
  SdAddons.prototype.currentQty = function () {
    var mb = window.multibuyState;
    if (mb && mb.items && mb.items.length) {
      var n = 0;
      mb.items.forEach(function (i) {
        n += toInt(i.quantity) || 1;
      });
      return Math.max(1, n);
    }
    var input = document.querySelector('#sd-product-form-' + this.sectionId + ' [name="quantity"]');
    return Math.max(1, toInt(input && input.value) || 1);
  };

  /* Combined spend = basket sofas + the sofa about to be added. The line
     being written is never part of the number being written, so the
     current product is added from the form, not read back off the cart. */
  SdAddons.prototype.combinedSpend = function () {
    var basket = basketSofas();
    var spend = basket.spend;
    var leather = basket.leather;

    var mb = window.multibuyState;
    if (mb && mb.items && mb.items.length) {
      mb.items.forEach(function (i) {
        spend += (toInt(i.price) || 0) * (toInt(i.quantity) || 1);
      });
    } else {
      var price = toInt(this.root.getAttribute('data-addon-current-price'));
      spend += price * this.currentQty();
    }

    if (this.root.getAttribute('data-addon-current-leather') === 'true') leather = true;
    return { spend: spend, material: leather ? 'leather' : 'fabric' };
  };

  /* Mirror of snippets/sd-addon-tier-pick.liquid. Keep the two in step:
     the product page quotes from the Liquid version and the basket charges
     from this one.

     Two rules here exist because of how care plans are actually stocked:

     • Stock may only veto a band when at least one band on the ladder
       reports stock. A store selling cover as a tracked product sitting on
       zero would otherwise have every band look sold out, leaving the
       shopper nothing to buy.
     • If NOTHING on the detected material's ladder resolves, fall back to
       the other ladder — a store stocking a single cover would otherwise
       leave a whole material empty. Never a fallback between BANDS, only
       between ladders: the band is what sets the price. */
  SdAddons.prototype.pickTier = function (spend, material) {
    var tiers = this.tiers;
    var order = material === 'fabric' ? ['fabric', 'leather'] : ['leather', 'fabric'];

    for (var m = 0; m < order.length; m++) {
      var pool = tiers.filter(function (t) {
        return t.material === order[m];
      });
      if (!pool.length) continue;

      var anyAvailable = pool.some(function (t) {
        return t.available;
      });
      var usable = anyAvailable
        ? pool.filter(function (t) {
            return t.available;
          })
        : pool;
      if (!usable.length) continue;

      var top = 0;
      usable.forEach(function (t) {
        if (t.hi > top) top = t.hi;
      });

      for (var k = 0; k < usable.length; k++) {
        var t = usable[k];
        if (spend >= t.lo && spend < t.hi) return t;
        /* Above every band, clamp to the top one. */
        if (spend >= top && t.hi === top) return t;
      }
    }
    /* Below the lowest band there is no cover to sell. */
    return null;
  };

  /* ── Keep every row's price honest ── */
  SdAddons.prototype.refresh = function () {
    var self = this;
    var qty = this.currentQty();

    this.rows.forEach(function (row) {
      var chk = row.querySelector('.sd-addon__check');
      var priceEl = row.querySelector('[data-addon-price-display]');
      if (!chk || !priceEl) return;
      if (row.hasAttribute('data-addon-care')) return;

      var unit = toInt(chk.dataset.addonPrice);
      var charges = row.getAttribute('data-addon-qty-follow') === 'true' ? followQty(qty) : 1;
      if (charges > 1) {
        priceEl.textContent = money(unit * charges);
        priceEl.setAttribute('title', money(unit) + ' × ' + charges);
      } else {
        priceEl.textContent = money(unit);
        priceEl.removeAttribute('title');
      }
    });

    if (this.careRow) this.refreshCare();

    this.publish();

    /* The running total on the Add-to-Cart button is owned by
       assets/sd-product.js; nudge it to recompute. */
    document.dispatchEvent(new CustomEvent('sd:addons-changed'));
  };

  SdAddons.prototype.refreshCare = function () {
    var row = this.careRow;
    var chk = row.querySelector('.sd-addon__check');
    var priceEl = row.querySelector('[data-addon-price-display]');
    var noteEl = row.querySelector('[data-addon-covers]');
    var titleEl = row.querySelector('.sd-addon__title');
    if (!chk) return;

    var ctx = this.combinedSpend();
    var tier = this.pickTier(ctx.spend, ctx.material);

    if (!tier) {
      /* Rendered but hidden AND disabled, so a basket that later crosses
         into range only needs the row shown, not built. A hidden row
         must also be disabled or it would still post. */
      row.hidden = true;
      chk.disabled = true;
      chk.checked = false;
      return;
    }

    row.hidden = false;
    chk.disabled = false;
    chk.dataset.addonVariant = String(tier.id);
    chk.dataset.addonPrice = String(tier.price);
    chk.value = money(tier.price);
    if (priceEl) priceEl.textContent = money(tier.price);
    if (titleEl && tier.title) titleEl.textContent = tier.title;
    if (noteEl && this.coversNote) {
      noteEl.textContent = this.coversNote.replace('[total]', money(ctx.spend));
    }

    /* Keep the popup's source of truth in step. */
    if (window.sdAddonData) {
      window.sdAddonData.forEach(function (d) {
        if (d.attr === 'Care Plan') {
          d.variantId = tier.id;
          d.rawPrice = tier.price;
          d.price = money(tier.price);
        }
      });
    }
  };

  /* ── window.sdAddonData ──
     assets/sd-cart-extras.js shows a pre-checkout popup on pages that have
     no product on them, so it reads this out of sessionStorage. Built from
     the rendered rows rather than printed by Liquid, so there is one source
     of truth and it cannot drift from what the shopper can actually see. */
  SdAddons.prototype.publish = function () {
    var data = [];
    this.rows.forEach(function (row) {
      if (row.hidden) return;
      var chk = row.querySelector('.sd-addon__check');
      if (!chk || chk.disabled) return;
      var title = row.querySelector('.sd-addon__title');
      var sub = row.querySelector('.sd-addon__sub');
      var img = row.querySelector('.sd-addon__icon-img');
      data.push({
        attr: row.getAttribute('data-addon-attr') || '',
        /* Charged per sofa, not per order — the popup multiplies by the
           basket's sofa count exactly as the product page does. */
        qtyFollow: row.getAttribute('data-addon-qty-follow') === 'true',
        variantId: toInt(chk.dataset.addonVariant) || null,
        rawPrice: toInt(chk.dataset.addonPrice),
        price: money(toInt(chk.dataset.addonPrice)),
        title: title ? title.textContent.trim() : '',
        sub: sub ? sub.textContent.trim() : '',
        image: img ? img.getAttribute('src') : ''
      });
    });
    window.sdAddonData = data;
    try {
      sessionStorage.setItem('sdAddonData', JSON.stringify(data));
    } catch (e) {
      /* Private browsing — the popup falls back to hiding its rows. */
    }
  };

  /* ── Variant dropdowns ── */
  SdAddons.prototype.initVariantSelects = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      var sel = e.target.closest ? e.target.closest('[data-addon-variant-select]') : null;
      if (!sel) return;
      var row = sel.closest('[data-addon-row]');
      var chk = row && row.querySelector('.sd-addon__check');
      var opt = sel.options[sel.selectedIndex];
      if (!chk || !opt) return;
      if (opt.dataset.variantId) chk.dataset.addonVariant = opt.dataset.variantId;
      if (opt.dataset.price) {
        chk.dataset.addonPrice = opt.dataset.price;
        chk.value = money(toInt(opt.dataset.price));
      }
      /* sdAddonData feeds the pre-checkout popup on other pages. */
      var attr = row.getAttribute('data-addon-attr');
      if (window.sdAddonData && attr) {
        window.sdAddonData.forEach(function (d) {
          if (d.attr !== attr) return;
          if (opt.dataset.variantId) d.variantId = parseInt(opt.dataset.variantId, 10);
          if (opt.dataset.price) {
            d.rawPrice = toInt(opt.dataset.price);
            d.price = money(toInt(opt.dataset.price));
          }
        });
      }
      self.refresh();
    });
  };

  /* ── Description dialog ── */
  SdAddons.prototype.initInfoDialogs = function () {
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-addon-info]') : null;
      if (!btn) return;
      e.preventDefault();
      var row = btn.closest('[data-addon-row]');
      var dlg = row && row.querySelector('dialog[data-addon-dialog]');
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    });

    this.root.addEventListener('click', function (e) {
      var more = e.target.closest ? e.target.closest('[data-addon-more]') : null;
      if (more) {
        e.preventDefault();
        var body = more.parentNode.querySelector('[data-addon-body]');
        if (!body) return;
        var open = body.classList.toggle('is-open');
        more.textContent = open ? 'Read less' : 'Read more';
        return;
      }
      var close = e.target.closest ? e.target.closest('[data-addon-close]') : null;
      if (close) {
        e.preventDefault();
        var dlg = close.closest('dialog');
        if (dlg) dlg.close();
      }
    });

    /* Clicking the backdrop closes. A <dialog> reports the click on
       itself when the backdrop is hit, so compare the target. */
    this.root.querySelectorAll('dialog[data-addon-dialog]').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    });
  };

  /* ── Nudge ──
     The list is BUILT FROM THE REAL ROWS rather than duplicated, so
     ticking here moves the real checkbox and the running total on the
     button stays honest. */
  SdAddons.prototype.buildNudge = function () {
    var dlg = document.getElementById('sd-addon-nudge');
    if (!dlg) return null;
    var list = dlg.querySelector('[data-nudge-list]');
    if (!list) return null;
    list.innerHTML = '';

    var any = false;
    this.rows.forEach(function (row) {
      if (row.hidden) return;
      var chk = row.querySelector('.sd-addon__check');
      if (!chk || chk.disabled || chk.checked) return;
      var title = row.querySelector('.sd-addon__title');
      var price = row.querySelector('[data-addon-price-display]');

      var id = 'sd-nudge-' + (chk.dataset.addonVariant || Math.random().toString(36).slice(2));
      var li = document.createElement('li');
      li.className = 'sd-addon-nudge__row';
      var label = document.createElement('label');
      label.setAttribute('for', id);
      var box = document.createElement('input');
      box.type = 'checkbox';
      box.id = id;
      box.className = 'sd-addon-nudge__check';
      /* Drive the REAL row, never a copy of its state. */
      box.addEventListener('change', function () {
        chk.checked = box.checked;
        chk.dispatchEvent(new Event('change', { bubbles: true }));
      });
      var text = document.createElement('span');
      text.textContent = (title ? title.textContent : 'Add-on').trim();
      var amt = document.createElement('span');
      amt.className = 'sd-addon-nudge__price';
      amt.textContent = price ? price.textContent : '';

      label.appendChild(box);
      label.appendChild(text);
      label.appendChild(amt);
      li.appendChild(label);
      list.appendChild(li);
      any = true;
    });

    /* The nudge lives outside the add-on block, so initInfoDialogs never sees
       it. Bound here, once, so clicking the backdrop cancels like it does on
       the description dialogs. */
    if (!dlg._sdBackdropBound) {
      dlg._sdBackdropBound = true;
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
    }

    return any ? dlg : null;
  };

  SdAddons.prototype.anyTicked = function () {
    return this.rows.some(function (row) {
      var chk = row.querySelector('.sd-addon__check');
      return chk && !chk.disabled && chk.checked;
    });
  };

  SdAddons.prototype.init = function () {
    var self = this;

    this.initVariantSelects();
    this.initInfoDialogs();

    /* Ticking a row changes the button total, which sd-product.js owns. */
    this.root.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('sd-addon__check')) {
        self.refresh();
      }
    });

    /* The care band moves with the variant, the stepper and the bundle. */
    document.addEventListener('sd:variant-changed', function (e) {
      if (e.detail && e.detail.price) {
        self.root.setAttribute('data-addon-current-price', e.detail.price);
      }
      self.refresh();
    });
    document.addEventListener('multibuy:change', function () {
      self.refresh();
    });
    var qtyInput = document.querySelector('#sd-product-form-' + this.sectionId + ' [name="quantity"]');
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        self.refresh();
      });
      qtyInput.addEventListener('input', function () {
        self.refresh();
      });
    }

    this.refresh();

    /* App-injected upsell widgets that would duplicate these rows. */
    var hide = this.root.getAttribute('data-addon-hide-selectors');
    if (hide) {
      hide.split(',').forEach(function (sel) {
        var s = sel.trim();
        if (!s) return;
        try {
          document.querySelectorAll(s).forEach(function (el) {
            el.style.display = 'none';
          });
        } catch (err) {
          /* A bad selector from a settings field must not take the page down. */
        }
      });
    }

    window.sdAddons = this;
  };

  /* ── The nudge gate, exposed for assets/sd-product.js ──
     Returns true when the add should proceed now, false when a dialog
     has been opened and will continue the add itself. */
  window.sdAddonsNudge = function (proceed) {
    var inst = window.sdAddons;
    if (!inst || !inst.root) return true;
    if (inst.root.getAttribute('data-addon-nudge') !== 'true') return true;
    if (inst.anyTicked()) return true;

    if (inst.root.getAttribute('data-addon-nudge-once') === 'true') {
      try {
        if (sessionStorage.getItem(NUDGE_KEY)) return true;
      } catch (e) {
        /* Private browsing: ask every time rather than never. */
      }
    }

    var dlg = inst.buildNudge();
    if (!dlg) return true;

    try {
      sessionStorage.setItem(NUDGE_KEY, '1');
    } catch (e) {}

    var done = false;
    function finish(go) {
      if (done) return;
      done = true;
      dlg.removeEventListener('close', onClose);
      if (go) proceed();
    }
    function onClose() {
      /* Escape and backdrop cancel; the buttons set returnValue. */
      finish(dlg.returnValue === 'continue');
    }
    dlg.addEventListener('close', onClose);

    dlg.returnValue = '';
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    return false;
  };

  function initAll() {
    document.querySelectorAll('[data-addon-root]').forEach(function (root) {
      if (root.dataset.addonInit) return;
      root.dataset.addonInit = '1';
      new SdAddons(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
